import { render, staticRenderFns } from "./addPMR.vue?vue&type=template&id=010e1a70&"
import script from "./addPMR.vue?vue&type=script&lang=js&"
export * from "./addPMR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports